import { ServerError } from '../types/ServerError';

export const getErrorMessage = (err: ServerError | any) => {
  const unwrappedError = err.data ?? err;
  const data = unwrappedError?.response?.data;
  return typeof data === 'object' ? data?.message : data;
};
